module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"title":"Settings"},"pt-BR":{"title":"Configurações"}}')
  delete Component.options._Ctor
}
